import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { styled } from '@mui/material/styles';
// Mui table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import axios from 'axios';

const StyledTableCell = styled(TableCell)(() => ({
  backgroundColor: 'white',
  borderTop: '1px solid #ddd',
  borderBottom: '1px solid #ddd',
  color: 'black',
}));

const DashGroupTB = ({ data }) => {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  const orgID = data;

  const userToken = JSON.parse(sessionStorage.getItem('login_info')).user_token;

  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/user/org-list/${userToken}`)
      .then((response) => {
        if (response.data[0] !== null || response.data[0] !== 'undefined')
          setRows(
            response.data[0].map((val) =>
              createData(
                `${val.user_name}`,
                `${val.email}`,
                `${val.authority}`,
                `${val.created_at}`,
                `${val.last_login}`
              )
            )
          );
      })
      .catch((response) => {
        console.log(response);
      });
  }, []);

  // 테이블 만들기
  function createData(name, account, auth, regist, lastLogin) {
    return { name, account, auth, regist, lastLogin };
  }

  //   createData(`${axiosData.license_type}`, `${axiosData.use_receipt_cnt}`, `${axiosData.available_bill_cnt}`, `${axiosData.available_customer_cnt}`, `${axiosData.end_date}`)

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">{t('이름')}</StyledTableCell>
            <StyledTableCell align="center">{t('계정')}</StyledTableCell>
            <StyledTableCell align="center">{t('권한')}</StyledTableCell>
            <StyledTableCell align="center">{t('등록일')}</StyledTableCell>
            <StyledTableCell align="center">{t('마지막 로그인')}</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{ borderBottom: '1px solid #ddd' }}>
          {rows.map((row, idx) => (
            <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row" style={{ borderBottom: '1px solid #ddd' }}>
                {row.name}
              </TableCell>
              <TableCell align="center" style={{ borderBottom: '1px solid #ddd' }}>
                {row.account}
              </TableCell>
              <TableCell align="center" style={{ borderBottom: '1px solid #ddd' }}>
                {row.auth}
              </TableCell>
              <TableCell align="center" style={{ borderBottom: '1px solid #ddd' }}>
                {row.regist}
              </TableCell>
              <TableCell align="center" style={{ borderBottom: '1px solid #ddd' }}>
                {row.lastLogin !== 'null' ? row.lastLogin : '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default React.memo(DashGroupTB);
